let ResetMindType =  {
    TOP_BOTTOM : 1, 
    LEFT_RIGHT : 2
}

export default ResetMindType
